export const NumResults = ({children}) => {
  return <p className='num-results'>{children}</p>;
};
